import { Skeleton } from '@/components/ui/skeleton';

/**
 * Renders `count` identical Skeleton placeholders. Centralises the one place
 * where a positional key is the correct identity: placeholders are never
 * reordered or individually updated, so their slot index is their identity.
 */
export const SkeletonList = ({ count = 3, className = '' }) =>
  Array.from({ length: count }, (_, slot) => (
    <Skeleton key={`slot-${slot}`} className={className} />
  ));
